/**
 * Date-range presets for inventory requirements (client-side).
 */

export const DATE_PRESETS = Object.freeze([
  { id: '1w', weeks: 1 },
  { id: '2w', weeks: 2 },
  { id: '3w', weeks: 3 },
  { id: '1m', months: 1 },
  { id: '2m', months: 2 },
  { id: '3m', months: 3 },
  { id: 'custom', custom: true },
]);

/**
 * @param {string} presetId
 * @returns {{ dateFrom: string, dateTo: string } | null}
 */
export function resolveDatePresetRange(presetId) {
  const preset = DATE_PRESETS.find((p) => p.id === presetId);
  if (!preset || preset.custom) return null;

  const to = new Date();
  const from = new Date();

  if (preset.weeks) {
    from.setDate(from.getDate() - preset.weeks * 7);
  } else if (preset.months) {
    from.setMonth(from.getMonth() - preset.months);
  }

  const fmt = (d) => d.toISOString().slice(0, 10);
  return { dateFrom: fmt(from), dateTo: fmt(to) };
}

/**
 * Build CSV string from requirement rows.
 * @param {object[]} rows
 * @param {string[]} headers
 * @param {(row: object) => string[]} rowToCells
 */
export function buildRequirementsCsv(rows, headers, rowToCells) {
  const escape = (v) => {
    const s = String(v ?? '');
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const lines = [headers.map(escape).join(',')];
  for (const row of rows) {
    lines.push(rowToCells(row).map(escape).join(','));
  }
  return lines.join('\n');
}

export function downloadCsvFile(filename, content) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
